import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { cn } from '@repo/utils'

import { ChildrenSchema } from 'utils'

import Icon from '../Icon'

import styles from './index.css'

class Link extends PureComponent {
  render() {
    const { as, children, className, href, ...props } = this.props
    const Element = as || RouterLink
    return (
      <Element {...props} className={cn(className, styles.link)} href={href} to={href}>
        {children}
        {props?.target === '_blank' && <Icon className={styles.icon} name="external" />}
      </Element>
    )
  }
}

Link.propTypes = {
  children: ChildrenSchema.isRequired,
  href: PropTypes.string.isRequired,

  as: PropTypes.string,
  className: PropTypes.string,
}

export default Link
